import { storyblokEditable } from "@storyblok/react";


const ArticleResults = ({ blok }) => {
  return (  
    <div className="article-results-section-wrap">
    <div {...storyblokEditable(blok)} className="font-display article-results-section-inner">
            <p className="article-result-number">{blok.resultnumber}</p>
            <p className="article-result-text">{blok.resulttext}</p>
    </div>
    </div>
  );
};

export default ArticleResults;